import { Box, Typography } from "@mui/material";

import { DateTime } from "luxon";

import { useAppSelector } from "app/hooks";

import { playbackSessionSelectors } from "./store/selectors.session";

export default function CurrentTime() {
    // marker on timeline
    const currentTimeStamp = useAppSelector(
        playbackSessionSelectors.selectCurrentPlaybackTimeStamp,
    );
    const currentDateTime = new Date(currentTimeStamp);
    const currentTime =
        DateTime.fromJSDate(currentDateTime).toFormat("HH:mm:ss");
    const currentDate =
        DateTime.fromJSDate(currentDateTime).toFormat("d-M-yyyy");

    return (
        <>
            <Box display="flex">
                <Typography sx={{ color: "white", fontSize: "small" }}>
                    {currentTime}
                </Typography>
                <Typography
                    sx={{
                        marginLeft: "10px",
                        color: "white",
                        fontSize: "small",
                    }}
                >
                    {currentDate}
                </Typography>
            </Box>
        </>
    );
}
